import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { reservasAPI } from "../../../utils/funcionesAPI";
import {
  stockEnDemanda,
  manejadorDeRespuesta,
  getTarifaBase,
  traerModalidadTarjeta,
} from "../../../utils/Tools";
import TarjetasBancoCuotasPedraza from "../../Global/TarjetasBancoCuotasPedraza";
import TotalConTarjeta from "../../Global/TotalConTarjeta";
import { toast } from "react-toastify";
import LoaderFormal from "../../Global/LoaderFormal";
import ReactGA from "react-ga";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import SeguroCancelacion from "./seguroCancelacion";
import TerminosYPoliticas from "./terminosYpoliticas";
import PuntosDeEmbarque from "./puntosDeEmbarque";
import CuadroEfectivo from "./cuadroEfectivo";
import CuadroDeposito from "./cuadroDeposito";
import CuadroTarjeta from "./cuadroTarjeta";
import NumberFormat from "react-number-format";
import PaymentForm from "../../Global/PaymentForms";

const Pago = (props) => {
  const {
    producto,
    charter,
    history,
    cabecera,
    totalPaquete,
    totalPaqueteConPlanFamily,
    cargosAdministrativos,
    tarifaNeta,
    impuestoPais,
    pasajerosAdultos,
    pasajerosMenores,
    totalSeguroCancelacion,
    puntosDeEmbarques,
    puntoDeEmbarque,
    onClickPuntoDeEmbarqueChange
  } = props;

  const token = sessionStorage.getItem("token");
  const user = sessionStorage.getItem("usuario");
  const tipoCliente = sessionStorage.getItem("tipoCliente");
  //const documento = sessionStorage.getItem("documento");
  //const nombreYapellido = sessionStorage.getItem("nombreYapellido");
  const datosDeFacturacion = JSON.parse(
    sessionStorage.getItem("datosDeFacturacion")
  );

  const calcularTotalPaquete = () => {
    let nuevototalPaquete = totalPaquete;
    if (totalPaqueteConPlanFamily > 0) {
      nuevototalPaquete = (totalPaqueteConPlanFamily + cargosAdministrativos)
        .toFixed(2)
        .toLocaleString();
    }

    return nuevototalPaquete;
  };

  const esInternacional = producto.moneda.codigoMoneda !== "PES";
  const tarifaPorHabitacion = producto.tarifaPorHabitacion === "1";
  const [idMedioDePago, setIdMedioDePago] = useState(
    tipoCliente === "IND" ? "3" : "1"
  );
  const [importeAPagar, setImporteAPagar] = useState(calcularTotalPaquete());
  const [
    importeAPagarConImpuestosYIntereses,
    setImporteAPagarConImpuestosYIntereses,
  ] = useState(0);
  const [importeProporcionalRGPais, setImporteProporcionalRGPais] =
    useState(impuestoPais);
  // const [puntosDeEmbarques, setPuntosDeEmbarques] = useState([]);
  const [modalidadTarjeta, setModalidadTarjeta] = useState("prisma");
  //const [puntoDeEmbarque, setPuntoDeEmbarque] = useState({});
  const [terminos, setTerminos] = useState(false);
  const [politicas, setPoliticas] = useState(false);
  const [loader, setLoader] = useState(false);
  const [habilitarBoton, setHabilitarBoton] = useState("ok");
  const [textoBoton, setTextoBoton] = useState(tipoCliente === "IND" ? "pagar" : "reservar");
  const [tarjetaElegida, setTarjetaElegida] = useState({ id: 0 });
  const [cuotaElegida, setCuotaElegida] = useState({
    id: 0,
    cantidad: 0,
    interes: 0,
  });
  // const [idBancoElegido, setIdBancoElegido] = useState(0);
  const [bancoElegido, setBancoElegido] = useState({});
  const [datosTarjeta, setDatosTarjeta] = useState({
    numeroTarjeta: "",
    mesExp: "",
    anioExp: "",
    cvc: "",
    cardHolderName: "",
    focus: "",
    tipoDocumento: {
      idTipoDocumento: "1",
      sigla: "DNI",
    },
    numeroDocumento: "",
    email: "",
  });

  useEffect(() => {
    traerModalidadTarjeta(setModalidadTarjeta);
  }, []);

  if (!token && !user) {
    props.history.push("/login");
  }

  if (
    (Object.keys(producto).length === 0 || Object.keys(charter).length === 0) &&
    !token
  ) {
    history.push("/login");
  }

  const resetearTotales = () => {
    setImporteAPagar(calcularTotalPaquete());
    setImporteAPagarConImpuestosYIntereses(calcularTotalPaquete());
    setImporteProporcionalRGPais(impuestoPais);
    setCuotaElegida({ id: 0, cantidad: 0, interes: 0 });
  };

  const handleMedioDePagoChange = (e) => {
    //si tiene el impuesto que aplica a todo
    if (producto.impuestoPAIS.coeficiente === 0) {
      if (e.target.value === "3") {
        props.onClickPagoConTarjetaConImpuesto(); //re calaculo totales CON impuesto si es tarjeta
        //this.handleRecalcularProporcionalImpuesto();
        //this.setState({idMedioDePago: e.target.value, bancoElegido: 0})
      } else {
        props.onClickPagoEfvoDepoConImpuesto(); //re calculo totales SIN impuestos si no es tarjeta
        //this.setState({idMedioDePago: e.target.value, importeAPagar: this.calcularTotalPaquete(), importeAPagarConImpuestosYIntereses: this.calcularTotalPaquete(), importeProporcionalRGPais: 0})
      }
    } /*else {//si no tiene impuesto

      if (e.target.value === '3') {
        //this.setState({idMedioDePago: e.target.value, bancoElegido: 0})
      } else {//reinicio valores a pagar si no es tarjeta
        //this.setState({idMedioDePago: e.target.value, importeAPagar: this.calcularTotalPaquete(), importeAPagarConImpuestosYIntereses: this.calcularTotalPaquete(), importeProporcionalRGPais: 0})
      }

    }*/
    setIdMedioDePago(e.target.value);
    if (e.target.value !== "3") {
      setTextoBoton("reservar");
    } else {
      setTextoBoton("pagar");
    }

    resetearTotales();
  };

  const handleImporteAPagarChange = (e) => {
    const numberWithoutDot = e.target.value.replace(",", "");
    handleRecalcularProporcionalImpuesto(numberWithoutDot);
    setImporteAPagar(numberWithoutDot);
  };

  /*
  const handlePuntoDeEmbarqueChange = (e) => {
    //const puntoEmb =  this.props.charter.puntosDeEmbarque.find((puntoEmb) => puntoEmb.idPuntoDeEmbarque === e.target.value)
    const puntoEmb = puntosDeEmbarques.find(
      (puntoEmb) => puntoEmb.idPuntoDeEmbarque === e.target.value
    );
    setPuntoDeEmbarque(puntoEmb);
  };
  */

  const handleTarjetaClick = (tarjetaEleg, cuotaElegida) => {
    setTarjetaElegida(tarjetaEleg);
    setCuotaElegida(cuotaElegida);
  };
  /*
  const handleBancoClick = (idBancoElegido) => {
    setIdBancoElegido(idBancoElegido);
  };
*/
  const handleBancoCompletoClick = (banco) => {
    setBancoElegido(banco);
  };

  const handleCuotaClick = (cuotaEleg) => {
    const subTotalImporteMasImpuesto =
      parseFloat(importeAPagar) + parseFloat(importeProporcionalRGPais);

    const nuevoImporteAPagar =
      subTotalImporteMasImpuesto +
      parseFloat((subTotalImporteMasImpuesto * cuotaEleg.interes) / 100);

    setCuotaElegida(cuotaEleg);
    setImporteAPagarConImpuestosYIntereses(nuevoImporteAPagar);
  };

  const handleIncluirSeguroDeCancelacionClick = (e) => {
    mostrarLoader(true);
    props.onClickIncluirSeguroDeCancelacion(e);
    setTimeout(function () {
      mostrarLoader(false);
    }, 2000);
    setIdMedioDePago(null);
  };

  const handleDatosTarjetaChange = (evt) => {
    const { name, value } = evt.target;
    setDatosTarjeta((prev) => ({ ...prev, [name]: value }));
  };

  const handleRecalcularProporcionalImpuesto = (importe) => {
    if (impuestoPais > 0) {
      const tarifaBase = tarifaPorHabitacion
        ? tarifaNeta
        : getTarifaBase(charter);
      const coeficienteTarifaBase = tarifaBase / totalPaquete;
      const importeProporcional = importe * coeficienteTarifaBase;
      const coeficienteImpuestosPaisProporicional = impuestoPais / tarifaBase; //0.2444
      const nuevoImpuestoPais =
        coeficienteImpuestosPaisProporicional * importeProporcional; //8003
      setImporteProporcionalRGPais(nuevoImpuestoPais);
      //calcularImpuestosPais(producto.idProducto, charter, pasajerosAdultos.length, cabecera, tipoCliente, importeProporcional, setImporteProporcionalRGPais, props);
      /*
      const coefTasa =
        1 - charter.tarifa.importeNoComisionable / charter.tarifa.tarifa;
      const coefRG27541 = producto.impuestoPAIS.valor / 100;
      const coefRG4815 = producto.impuestoPAIS.resolucion2 / 100;

     // const coeficienteTarifaBase = charter.tarifa.tarifa
      //const tarifaBaseIva = charter.tarifa.tarifa - charter.tarifa.importeNoComisionable;
      //const iva = (tarifaBaseIva * producto.coeficienteTasaNormal / 1.21) + (tarifaBaseIva * producto.coeficienteSobreTasa / 1.105);
      const tarifa = (charter.tarifa.tarifa -
        charter.tarifa.tarifa * (charter.promoValijaYa / 100));
      const montoProporcionalImpuestoRG27541 = impuestoPais * coefRG27541;
      const montoProporcionalImpuestoRG4815 = impuestoPais * coefRG4815;
      const coeficienteTotalRG27541 = montoProporcionalImpuestoRG27541 / charter.tarifa.tarifa;
      const coeficienteTotallRG4815 = montoProporcionalImpuestoRG4815 / charter.tarifa.tarifa;
      const proporcionalRG27541Importe = importe * coefProporcionalRG27541;
      //const coefBaseImponible = ; 
      const coefAplicacion =
        parseFloat(coefTasa.toFixed(6)) * coefRG27541 * coefRG4815 * producto.impuestoPAIS.coeficiente;

      const coefAplicar = 1 + coefAplicacion;
      //importeQuePaga = Es el importe que tipea el cliente que quiere pagar. No menos del 30% del total del viaje

      //ProcentajePais = Es el porcentaje de la RG que se debe aplicar obtenida del query
      //const infoas = despejarInfoas(this.props.pasajerosMenores);//function en Tools
      //const pasajerosPagantes = this.props.pasajerosAdultos.length + this.props.pasajerosMenores.length - infoas;

      const importeProporcionalRGPais = importe - importe / coefAplicar;

      //const importeRGPaisPQ = importeRGPaisCL / cot_PQ;//  (por si necestias tener el valor en moneda del Paquete)
      //Este importe importeRGPaisCL  es que se suma al importeQuePaga y es el que viaja a FirstData
      //const importeFirstFData =  this.state.importeAPagarConImpuestosYIntereses + importeProporcionalRGPais;
      setImporteProporcionalRGPais(importeProporcionalRGPais);
      */
    }
  };

  /*
  const handlePasoPagarClick = (e) => {
    props.onPasoPagarClick();
  };
  */
  const mostrarLoader = (estado) => {
    setLoader(estado);
  };

  const handlePreReservarClick = (e) => {
    e.preventDefault();
    const medioPago = Number(idMedioDePago);

    if (modalidadTarjeta === "firstData") {
      if (medioPago === 3) {
        confirmAlert({
          title: "Pago con Tarjeta de Crédito",
          message:
            "En unos instantes será redirigido a para realizar el pago de su reserva. Por favor no cierre el navegador en esta instancia ¿Está seguro de continuar?",
          buttons: [
            {
              label: "Si",
              onClick: () => {
                handleReservarClick(e);
              },
            },
            {
              label: "No",
              onClick: () => {
                return;
              },
            },
          ],
        });
      } else {
        handleReservarClick(e);
      }
    } else {
      handleReservarClick(e);
    }
  };

  const esValidoElTitularTarjeta = (
    listaPasajeros,
    documentoTitularTarjeta
  ) => {
    let rto = listaPasajeros.some(
      (pax) => pax.documento === documentoTitularTarjeta
    );

    return rto;
  };

  const handleReservarClick = (e) => {
    e.preventDefault();

    const tokenEnSesion = sessionStorage.getItem("token");
    let medioPago = Number(idMedioDePago);
    const totalOriginal = calcularTotalPaquete();
    let pagoElectronico = {};
    let pasajeros = pasajerosAdultos.concat(pasajerosMenores);

    if (!terminos || !politicas) {
      toast.info(
        "Debe aceptar los Términos y Condiciones y las Políticas de Menores",
        {
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      return;
    }

    if (!medioPago) {
      toast.info("Debe seleccionar algún medio de pago", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (medioPago === 3) {
      if (parseFloat(importeAPagar) < totalOriginal * 0.3) {
        toast.info("Debe abonar al menos el 30% del total de la reserva", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return;
      }

      if (cuotaElegida.id === 0) {
        toast.info("Debe seleccionar un plan de cuotas", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return;
      }

      const {
        numeroTarjeta,
        mesExp,
        anioExp,
        cvc,
        cardHolderName,
        numeroDocumento,
        email,
      } = datosTarjeta;

      if (modalidadTarjeta === "prisma") {
        if (
          numeroTarjeta === "" ||
          mesExp === "" ||
          anioExp === "" ||
          cvc === "" ||
          cardHolderName === "" ||
          numeroDocumento === "" ||
          email === "" ||
          !bancoElegido.id ||
          !tarjetaElegida.id ||
          !cuotaElegida.cantidad
        ) {
          toast.info("Debe comlpetar todos los campos de la tarjeta", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          return;
        }

        //FC: si usa tarjeta de 3ro, le cambio el modo de pago, paso a ser paga despues para generarle la reserva
        if (
          !esValidoElTitularTarjeta(pasajeros, numeroDocumento) &&
          tipoCliente === "IND"
        ) {
          toast.info(
            "Los datos de la tarjeta, no coinciden con la nomina de los pasajeros ingresados. Si desea abonar con una tarjeta de terceros deberá acercarse a alguna de nuestras sucursales. Igualmente la reserva ah sido efectuada y podrá verla desde MIS RESERVAS donde podrá abonarla con una tarjeta asociada a alguno de los pasajeros.",
            {
              position: toast.POSITION.BOTTOM_CENTER,
            }
          );
          medioPago = 1;
        }
      }

      const interes =
        parseFloat(importeAPagar) * parseFloat(cuotaElegida.interes / 100);

      pagoElectronico = {
        intereses: interes,
        totalPagar: importeAPagar,
        datosTarjeta,
        tarjetaElegida,
        cuotaElegida,
        bancoElegido,
      };
    }

    if (
      puntosDeEmbarques.length > 0 &&
      !puntoDeEmbarque.hasOwnProperty("idPuntoDeEmbarque")
    ) {
      toast.info("Debe seleccionar un Punto de Embarque", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    //usuarioWeb: usuario, $idchar, $idprodcab, $cantidad, $cantidadadult, $desde, $codcli, $stok, $idcliente, $habitacion, $cantidadinfoa, 'M'
    if (Object.keys(pasajeros[0]).length === 0) pasajeros = [];
    //const archivo = JSON.parse(atob(datosDeFacturacion.archivo));
    setTextoBoton("procesando...");
    setHabilitarBoton("");

    const reserva = {
      charter,
      producto,
      pasajeros,
      cabecera,
      medioDePago: medioPago,
      totalOriginal,
      importeAPagar,
      puntoDeEmbarque: puntosDeEmbarques.find(p => p.idPuntoDeEmbarque === puntoDeEmbarque.idPuntoDeEmbarque),
      aplicaPlanFamily: totalPaqueteConPlanFamily,
      canal: "WEB",
      //idBancoElegido,
      totalSeguroCancelacion,
      pagoElectronico,
      datosDeFacturacion,
    };

    const data = JSON.stringify({
      peticion: medioPago,
      reserva: reserva,
      token: tokenEnSesion,
      modalidadTarjeta,
    });

    ReactGA.initialize("UA-54854159-9");

    //  window.location.href = 'http://localhost/pedraza/webPedraza2018/firstdata/index.php?numeroReserva=123&total='+importeAPagar;

    mostrarLoader(true);

    reservasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        ReactGA.event({
          category: "Reservas",
          action: "Reservar",
        });

        if (medioPago === 3) {
          toast.success("Redirigiendo...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });

          window.location.href = respuesta && respuesta.data;
        } else {
          props.onReservarClick(respuesta.data, medioPago);
        }
      } else {
        //cuando es error
        if (medioPago === 3 && respuesta && respuesta.callback) {
          window.location.href = respuesta.callback;
        }

        setHabilitarBoton("ok");
        setTextoBoton("Pagar");
        stockEnDemanda(9);
      }
      mostrarLoader(false);
    });
  };

  return (
    <div className="title">
      <LoaderFormal loaded={loader} mensaje="Abriendo..." />

      {/*charter.puntosDeEmbarque.length > 0 ? <section>*/}
      {puntosDeEmbarques.length > 0 && (
        <PuntosDeEmbarque
          onPuntoDeEmbarqueChange={onClickPuntoDeEmbarqueChange}
          puntosDeEmbarques={puntosDeEmbarques}
          puntoDeEmbarqueSeleccionado={puntoDeEmbarque}
        />
      )}
      <br />
      <section className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 terms clearfix">
        <SeguroCancelacion
          onIncluirSeguroDeCancelacionClick={
            handleIncluirSeguroDeCancelacionClick
          }
        />
      </section>
      {tipoCliente === "IND" && (
      <section className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 payment clearfix">
        <h2>Pago</h2>
        <hr />
        <h4>
          <i className="material-icons iconos-pagos">payment</i> elija el
          m&eacute;todo de pago
        </h4>
        <ul className="row">
          {/* {(tipoCliente !== "IND" || esInternacional) && (
            <CuadroEfectivo
              idMedioDePago={idMedioDePago}
              onMedioDePagoChange={handleMedioDePagoChange}
              esInternacional={esInternacional}
            />
          )} */}
          {tipoCliente === "IND" && (
            <CuadroTarjeta
              idMedioDePago={idMedioDePago}
              onMedioDePagoChange={handleMedioDePagoChange}
              codigoMoneda={producto.moneda.codigoMoneda}
              classes={{
                contenedorTarjeta: `col-xl-${
                  tipoCliente === "IND" && !esInternacional ? "12" : "4"
                } col-lg-${
                  tipoCliente === "IND" && !esInternacional ? "12" : "4"
                } col-md-12 col-sm-12 col-12`,
              }}
            >
              {idMedioDePago === "3" && (
                <div>
                  <ImporteAPagar
                    importeAPagar={importeAPagar}
                    totalPaquete={totalPaquete}
                    tipoCliente={tipoCliente}
                    onImporteAPagarChange={handleImporteAPagarChange}
                  />
                </div>
              )}
            </CuadroTarjeta>
          )}

          {/* {tipoCliente !== "IND" && !esInternacional && (
            <CuadroDeposito
              idMedioDePago={idMedioDePago}
              onMedioDePagoChange={handleMedioDePagoChange}
              codigoMoneda={producto.moneda.codigoMoneda}
            />
          )} */}
        </ul>

        {idMedioDePago === "3" && (
          <div>
            <div className="aside">
              <TarjetasBancoCuotasPedraza
                cuotaElegida={cuotaElegida}
                tarjetaElegida={tarjetaElegida}
                onTarjetaClick={handleTarjetaClick}
                //onBancoClick={handleBancoClick}
                onBancoClick={handleBancoCompletoClick}
                onCuotaClick={handleCuotaClick}
                producto={producto}
                codigoMoneda={producto.moneda.codigoMoneda}
              />

              <h4 style={{ fontSize: "1rem", textTransform: "uppercase" }}>
                Atencion: <br />
                <br />
                Para el pago online SOLO se aceptarán tarjetas de crédito o
                débito <i className="material-icons iconos-pagos">payment</i> a
                nombre de alguno de los pasajeros. Si desea abonar con una
                tarjeta de un tercero, puede avanzar con el proceso de reserva
                ahora pero deberá abonarlo de manera presencial en alguna de
                nuestras sucursales en un plazo menor a 48hs, ya que la misma
                tiene vencimiento.
                <br />
                <br />
                Para embarcar, sera obligatorio presentar el voucher, el DNI y
                tarjeta con la que se realizó el pago. De no cumplir con este
                requisito, no podra viajar. <br />
                <br />
                Para mas información puede comunicarse a cualquiera de nuestros
                números
              </h4>
              {modalidadTarjeta === "prisma" && (
                <PaymentForm
                  datosTarjeta={datosTarjeta}
                  onHandleDatosTarjetaChange={handleDatosTarjetaChange}
                />
              )}
            </div>

            <TotalConTarjeta
              cuotaElegida={cuotaElegida}
              totalPaquete={totalPaquete}
              impuestoPais={impuestoPais}
              importeAPagar={importeAPagar}
              importeProporcionalRGPais={importeProporcionalRGPais}
              importeAPagarConImpuestosYIntereses={
                importeAPagarConImpuestosYIntereses
              }
            />
          </div>
        )}
      </section>
       )}
      <section className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 terms clearfix">
        <TerminosYPoliticas
          setTerminos={setTerminos}
          terminos={terminos}
          setPoliticas={setPoliticas}
          politicas={politicas}
        />

        <br />
        <button
          type="submit"
          disabled={!habilitarBoton}
          onClick={handlePreReservarClick}
          className="submitCargaPasajeros"
        >
          {textoBoton}
        </button>
        {/*<div className="listado">
                <Link to='/paquete-turistico/proceso-compra/'>Volver al Paso 2</Link>
              </div>*/}
      </section>
    </div>
  );
};

export default withRouter(Pago);

function ImporteAPagar(props) {
  const { importeAPagar, onImporteAPagarChange, totalPaquete, tipoCliente } =
    props;
  //const onImporteAPagarChange = props.onImporteAPagarChange;
  return (
    <div>
      <p style={{ margin: "0" }} className="parrafoEnMedioDePago">
        Ingrese el monto a pagar
      </p>
      <NumberFormat
        disabled={tipoCliente === "IND"}
        value={importeAPagar}
        className="importeAPagar"
        name="importeAPagar"
        displayType={"input"}
        thousandSeparator=","
        allowNegative={false}
        fixedDecimalScale={true}
        decimalScale={2}
        decimalSeparator="."
        onChange={onImporteAPagarChange}
      />
      {/*  <input
        className="importeAPagar"
        type="number"
        step="0.01"
        name="importeAPagar"
        onChange={props.onImporteAPagarChange}
        placeholder="Importe a Pagar"
        value={props.importeAPagar}
      /> */}
      {tipoCliente !== "IND" && (
        <p className="parrafoEnMedioDePago">
          Debe abonar como mínimo una suma de $ {Math.ceil(totalPaquete * 0.3)}{" "}
          para reservar
        </p>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/Pago/index.js